import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { $tk } from 'utils/appTranslationKey';
import { PromotionStatsFC, PromotionStatsFCProps } from './PromotionStatsFC';

const useStrings = (): PromotionStatsFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      orders: intl.formatMessage({ id: $tk.components.PromotionStats.orders }),
      customers: intl.formatMessage({ id: $tk.components.PromotionStats.customers }),
      update: intl.formatMessage({ id: $tk.components.PromotionStats.update }),
      noOrders: intl.formatMessage({ id: $tk.components.PromotionStats.noOrders }),
      newCustomers: intl.formatMessage({ id: $tk.components.PromotionStats.newCustomers }),
      totalSpends: intl.formatMessage({
        id: $tk.components.activePromotionsGrid.statsTitles.spend,
      }),
      totalRevenue: intl.formatMessage({ id: $tk.components.PromotionStats.totalRevenue }),
    }),
    [intl],
  );
};

type PromotionStatsProps = Omit<PromotionStatsFCProps, 'strings'>;

export function PromotionStats(props: PromotionStatsProps) {
  const strings = useStrings();
  return <PromotionStatsFC {...props} strings={strings} />;
}
